import React from 'react'

import { Badge } from '@rewardops/replit/src/components/ui/badge'
import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'

import { PAWSectionType } from './paw-section-types'

export const Effectiveness: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  return (
    <section data-testid="section-manager-effectiveness">
      <h2 className="mb-6 text-xl font-semibold">{content?.title}</h2>
      <Card>
        <CardContent className="pt-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="p-3 text-left font-medium">Manager</th>
                  <th className="p-3 text-left font-medium">Team</th>
                  {data?.showGoals && (
                    <th className="p-3 text-center font-medium">
                      Team Attainment
                    </th>
                  )}
                  <th className="p-3 text-center font-medium">
                    Campaign Adoption
                  </th>
                  <th className="p-3 text-center font-medium">Training</th>
                </tr>
              </thead>
              <tbody>
                {data?.managerMetrics.map((manager: any, index: number) => (
                  <tr key={index} className="border-b hover:bg-muted/50">
                    <td className="p-3 font-medium">{manager.name}</td>
                    <td className="p-3 text-muted-foreground">
                      {manager.team}
                    </td>
                    {data?.showGoals && (
                      <td className="p-3 text-center">
                        <Badge
                          variant={
                            manager.teamAttainment >= 100
                              ? 'default'
                              : manager.teamAttainment >= 80
                              ? 'secondary'
                              : 'destructive'
                          }
                        >
                          {manager.teamAttainment}%
                        </Badge>
                      </td>
                    )}
                    <td className="p-3 text-center">
                      {manager.campaignAdoption}%
                    </td>
                    <td className="p-3 text-center">
                      {manager.trainingCompletion}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </section>
  )
}
